module.exports = __webpack_public_path__ + "static/media/boat-ice-iceberg-svgrepo-com.4e304cbd.svg";